/**
 * Prints once every image on the page has loaded and decoded — an image
 * still arriving prints as an empty box. Never waits more than a few
 * seconds: a broken image should not stop the page printing.
 *
 * "Save as PDF" is the browser's own print dialog: text stays text, so the
 * PDF is crisp and searchable, and nothing has to lay the page out twice.
 */
export async function printWhenReady(): Promise<void> {
  const images = [...document.images];
  const ready = Promise.all(
    images.map((image) =>
      image.complete && image.naturalWidth > 0
        ? image.decode().catch(() => undefined)
        : new Promise<void>((resolve) => {
            image.addEventListener('load', () => {
              resolve();
            });
            image.addEventListener('error', () => {
              resolve();
            });
          }),
    ),
  );
  await Promise.race([
    ready,
    new Promise((resolve) => setTimeout(resolve, 8000)),
  ]);
  window.print();
}
